import { ParsedTime } from "../interfaces/ParsedTime";
import parseSeconds from "./parseSeconds";
import t from "../i18n";

export default function formatTime(time: ParsedTime, suffix: string): string {
  const availableTimeIntervals = Object.keys(time).filter((key) => time[key]);

  if (availableTimeIntervals.length > 1) {
    return `${time[availableTimeIntervals[0]]}${t(availableTimeIntervals[0])} ${
      time[availableTimeIntervals[1]]
    }${t(availableTimeIntervals[1])}${suffix}`;
  }
  if (availableTimeIntervals.length === 0) {
    return t("Time Up");
  }

  return `${time[availableTimeIntervals[0]]}${t(
    availableTimeIntervals[0],
  )}${suffix}`;
}

export function getFormattedTime(time: number) {
  const parsedTime = parseSeconds(time);
  return formatTime(parsedTime, "");
}

export function getFormattedTimeLeft(endTime: number) {
  const secondsLeft = endTime - +new Date() / 1000;
  const parsedTime = parseSeconds(secondsLeft);
  return formatTime(parsedTime, t(" remaining"));
}

export function turnAsDate(turn: number, variant: string): string {
  // TODO: For now I'm just adding the case for "Classic"
  let phase = "";
  if (turn === -1) return t("Pre-game");
  switch (variant) {
    case "Classic": {
      const year = Math.floor(turn / 2) + 1901;
      const season = turn % 2 ? t("Autumn") : t("Spring");
      phase = `${season}, ${year}`;
      break;
    }
    default:
      break;
  }
  return phase;
}
